// ============================================================
// EDIT ME — Digital products (preview cards)
// Origin Speed Academy / Online Coaching is LIVE — these preview
// cards direct athletes to start online coaching or book a free
// evaluation. Add a `buyUrl` later to sell a standalone product.
// ============================================================
const TRAIN_IMG = [
  "https://images.unsplash.com/photo-1474546652694-a33dd8161d66?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1549896869-ca27eeffe4fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1502904550040-7534597429ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/38149422/pexels-photo-38149422.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.pexels.com/photos/12698200/pexels-photo-12698200.jpeg?auto=compress&cs=tinysrgb&w=1200",
];

export const DIGITAL_PRODUCTS = [
  { title: "Sprint Mechanics Course", desc: "Master efficient sprint technique from the ground up.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[0] },
  { title: "Speed Development Program", desc: "The complete system to get measurably faster.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[1] },
  { title: "Vertical Jump Program", desc: "Build explosive lower-body power and hops.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[2] },
  { title: "Acceleration Program", desc: "Win the first ten yards — dominate off the line.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[3] },
  { title: "Youth Athlete Training Guide", desc: "Age-appropriate development for young athletes.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[4] },
  { title: "Mobility & Recovery Program", desc: "Move better, recover faster, stay durable.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[5] },
  { title: "Off-Season Performance Blueprint", desc: "Turn the off-season into your biggest advantage.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[0] },
  { title: "Strength & Power Program", desc: "Force production that transfers to the field.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[1] },
  { title: "Game Speed Program", desc: "Convert raw speed into usable, reactive game speed.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[2] },
  { title: "Sport-Specific Performance Programs", desc: "Tailored programming for your sport & position.", buyUrl: "", learnMoreUrl: "", img: TRAIN_IMG[3] },
];

// ============================================================
// EDIT ME — Merchandise / Shop (Stripe-ready showcase)
// Add real prices + sizes + `buyUrl` when the store goes live.
// ============================================================
export const MERCH = [
  {
    name: "JJSF Performance Tee",
    price: "Coming Soon",
    desc: "Premium moisture-wicking training tee with the JJ Speed Factory mark.",
    img: "https://customer-assets-jai6qajn.emergentagent.net/job_faster-explosive/artifacts/vxq0dhdn_9A6A6CDF-9EBC-45D8-98ED-D5BFC36BCADD.png",
  },
];

// ============================================================
// EDIT ME — Training options / pricing
// ============================================================
export const TRAINING_OPTIONS = [
  {
    name: "Private Sessions",
    price: "Contact for pricing",
    includes: ["1-on-1 elite coaching", "Fully individualized plan", "Flexible scheduling", "Fastest results"],
    cta: "Book Free Evaluation",
    target: "#assessment",
  },
  {
    name: "Small Group Training",
    price: "Contact for pricing",
    includes: ["2–6 athletes", "Competitive environment", "Premium coaching, shared cost", "Most popular option"],
    cta: "Start Training",
    target: "#assessment",
    featured: true,
  },
  {
    name: "Team Training",
    price: "Custom quote",
    includes: ["Schools, clubs & orgs", "Speed, agility & power", "Sprint mechanics & conditioning", "On-site options"],
    cta: "Request Team Training",
    target: "#contact",
  },
  {
    name: "Monthly Membership",
    price: "Now Enrolling",
    includes: ["Ongoing programming", "Priority scheduling", "Member pricing", "Continuous progress tracking"],
    cta: "View Memberships",
    href: "/memberships",
  },
  {
    name: "Camps & Clinics",
    price: "Per event",
    includes: ["Youth → college", "Hosted across the region", "Group rates available", "Special events"],
    cta: "Join a Camp",
    target: "#contact",
  },
  {
    name: "Online Coaching",
    price: "From $175/mo",
    includes: ["Train anywhere", "Proven JJ systems", "Remote video analysis", "Origin Speed Academy access"],
    cta: "Start Online Coaching",
    href: "/online-coaching",
  },
];
